import { FeeType, type NewFee } from '@acre/graphql'

const newFee: NewFee = {
  __typename: 'NewFee',
  fee_type: FeeType.InvalidFeeType,
  value: '',
}

export default newFee
